// extracted by mini-css-extract-plugin
export default {"section":"AutomatedEmailsConstants_section__xc8DK","wrapper":"AutomatedEmailsConstants_wrapper__hSUo9","item":"AutomatedEmailsConstants_item__ODJZ9"};